import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "children", "extra", "text", "copied", "collapse", "visibleButton", "visible"];
import React, { useContext, useEffect } from 'react';
import { CODE_PREVIEW_PREFIX } from './CodePreview';
import { Copied } from './Copied';
import { ExpandIcon } from './icons';
import { Context } from './store';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Toolbar = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      className,
      children,
      extra,
      text = '',
      copied = true,
      collapse = true,
      visibleButton = true,
      visible = true
    } = props,
    htmlProps = _objectWithoutPropertiesLoose(props, _excluded);
  var store = useContext(Context);
  var cls = [CODE_PREVIEW_PREFIX + "-toolbar", className].filter(Boolean).join(' ').trim();
  useEffect(() => store.dispatch({
    collapse
  }), [collapse]);
  if (!visible) {
    return null;
  }
  var handleClick = () => store.dispatch({
    collapse: !store.collapse
  });
  return /*#__PURE__*/_jsxs("div", _extends({
    className: cls
  }, htmlProps, {
    ref: ref,
    children: [/*#__PURE__*/_jsx("div", {
      className: CODE_PREVIEW_PREFIX + "-title",
      children: children
    }), /*#__PURE__*/_jsxs("div", {
      className: CODE_PREVIEW_PREFIX + "-extra",
      children: [extra, copied && /*#__PURE__*/_jsx(Copied, {
        text: text
      }), visibleButton && /*#__PURE__*/_jsx("button", {
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(ExpandIcon, {})
      })]
    })]
  }));
});
Toolbar.displayName = 'uiw.Toolbar';